module.exports = __webpack_public_path__ + "img/AddApartment.55feac4f.svg";